import { dayjsWithTimezone, parseJson } from '@healthhub/react-ui';

import { getI18nCacheKey, getI18nLastModifiedCacheKey } from './getI18nCacheKey';

export const getI18nValidCacheLastModified = (language: string, namespace: string): null | string => {
  const cacheLastModified = localStorage.getItem(getI18nLastModifiedCacheKey(language, namespace));
  const cacheTranslation = localStorage.getItem(getI18nCacheKey(language, namespace));

  if (!cacheTranslation || !cacheLastModified) {
    return null;
  }

  try {
    parseJson(cacheTranslation);
  } catch (error) {
    console.error(`Invalid cached translation for ${language}-${namespace}.`, error);
    return null;
  }

  return dayjsWithTimezone(cacheLastModified).isValid() ? cacheLastModified : null;
};
